import axios from 'axios';
import { useAuthStore } from '@/stores/auth';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
  timeout: 10000,
});

// 요청 인터셉터
api.interceptors.request.use(
  (config) => {
    console.log('axios 인터셉터 - 요청 전:', {
      url: config.url,
      headers: config.headers
    });

    const authStore = useAuthStore();
    
    // 토큰이 있으면 Authorization 헤더 추가
    const token = authStore.getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // 테넌트 ID가 있으면 X-Tenant-ID 헤더 추가
    if (authStore.tenantId) {
      config.headers['X-Tenant-ID'] = authStore.tenantId;
    }
    
    return config;
  },
  (error) => {
    console.error('axios 인터셉터 - 요청 에러:', error);
    return Promise.reject(error);
  }
);

// 응답 인터셉터
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('axios 인터셉터 - 응답 에러:', {
      config: error.config,
      response: error.response
    });

    if (error.response?.status === 401) {
      const authStore = useAuthStore();
      authStore.clearAuthData();
      window.location.href = '/auth/login';
    }
    return Promise.reject(error);
  }
);

export default api; 